<template>
   <div id="app">
      <router-view name="primaryNavigation" />
      <!-- <div class="page-container"> -->
      <!--  <div class="manipulator" :class="bannerAvailable ? 'mt-5' : ''" />-->
      <div id="mainContainer" class="main-container">
         <div class="content-container">
            <transition name="fade">
               <div :class="['main-layout', sidebarClass, { 'has-sidebar': routeHasSidebar }]">
                  <router-view v-if="isSidebarTreeEnable" name="sideBar" />
                  <router-view class="container-content" />
               </div>
            </transition>
         </div>
      </div>
      <!-- </div> -->
      <router-view name="primaryFooter" />
   </div>
</template>

<script>
import Vue from 'vue';
import 'swiper/dist/css/swiper.css';
import { mapState } from 'vuex';

export default {
   data: () => ({
      sidebarClass: '',
   }),
   computed: {
      ...mapState(['isSidebarTreeEnable', 'bannerAvailable']),
      // isSidebarTreeEnable defaults to true store-wide and only some
      // pages ever flip it false, so it doesn't reliably say whether THIS
      // route actually renders a sidebar (e.g. it stays true on the home
      // page, which has no sideBar view at all). Check the matched route's
      // own component map instead - only routes that register one
      // (fusiontime, chart-guide, etc.) get the mobile sidebar-clearance
      // CSS below.
      routeHasSidebar() {
         return this.$route.matched.some(record => record.components && record.components.sideBar);
      },
   },
   beforeMount() {
      // eslint-disable-next-line
      const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
      Vue.use(VueAwesomeSwiper);
   },

   mounted() {
      const [{ props }] = this.$route.matched;
      this.sidebarClass = props.default && props.default.sidebarClass;

      // Marketing Cookie Integration
      const markettingParams = [
         'gclid',
         'utm_content',
         'utm_term',
         'utm_campaign',
         'utm_medium',
         'utm_source',
         'label',
         'campaign',
         'adposition',
         'network',
         'locphysical',
         'locinterest',
         'targetid',
         'device',
         'keyword',
         'group',
      ];

      const params = new URL(document.location).searchParams;
      if (typeof params !== 'undefined' && params) {
         for (let arrayIndex = 0; arrayIndex < markettingParams.length; arrayIndex++) {
            if (params.get(markettingParams[arrayIndex])) {
               this.setCookie(
                  markettingParams[arrayIndex],
                  params.get(markettingParams[arrayIndex]),
                  30
               );
            }
         }
      }
      FusionCharts.options.license({
         key:
            'PtB2dF-7wB4C5C3D5D3B3D3H3C8A8D2B3F6tgoD3B1d1fdzoG4I3I-7jD-17A3D5B3D5D4B3C3C3D7B4C2A4G5G1D2G1rmoE6E1C4H1rF-7c1eeOeoB-8dbB2pA-13xB2C1C1ihC-21B1E6B1ycrA33A18B14isqB4A2H4C1J4A2A11C1A3C1E3vxxC5B7CE2C-11xoH1F2C2fuC7d1D4G4ccC-22C6D4B5D1D1E1H2G1A11D9C1E5B5B2j==',
         creditLabel: false,
      });
      window.addEventListener('load', () => {
         const addScript = (src, position = 'body', async = true) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = async;
            document[position].appendChild(script);
         };

         if (process.env.NODE_ENV === 'production') {
            // Load your GTM container after page load
            addScript('/public/js/gtm.js', 'body');
         }
      });
      window.addEventListener('load', () => {
         const addScript = (src, position = 'body') => {
            const script = document.createElement('script');
            script.src = src;
            script.async = false;
            script.type = 'text/javascript';
            document[position].appendChild(script);
         };

         // Scripts only for production
         /* if (process.env.NODE_ENV === 'production') {
            addScript('/public/js/gtm.js', 'head');
         } */
         addScript('/public/js/utm.js');
         // FusionCharts Themes - pinned to the same version as the core
         // fusioncharts.js script in index.template.html. These were
         // previously pulling from "latest", which could re-register (via
         // FusionCharts.addTheme) a differently-versioned gammel theme than
         // the one index.template.html eager-loads for first paint.
         addScript('https://cdnjs.cloudflare.com/ajax/libs/gumshoe/3.5.1/js/gumshoe.min.js');
         addScript(
            'https://cdn.fusioncharts.com/fusioncharts/3.19.0/themes/fusioncharts.theme.gammel.js'
         );
         addScript(
            'https://cdn.fusioncharts.com/fusioncharts/3.19.0/themes/fusioncharts.theme.umber.js'
         );
         addScript(
            'https://cdn.fusioncharts.com/fusioncharts/3.19.0/themes/fusioncharts.theme.zune.js'
         );
         addScript(
            'https://cdn.fusioncharts.com/fusioncharts/3.19.0/themes/fusioncharts.theme.ocean.js'
         );
      });

      if (window && window.ga) {
         const { fullPath } = this.$route;
         window.ga('gtm2.send', 'pageview', {
            page: fullPath,
            title: document.title,
         });
      }
   },

   methods: {
      setCookie(name, value, days) {
         let expires = '';
         if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires= ${date.toUTCString()}`;
         }
         document.cookie = `${name}  =  ${value}    ${expires}  ; domain=.fusioncharts.com;path=/`;
      },
   },

   metaInfo() {
      return {
         title: 'FusionCharts',
      };
   },
};
</script>

<style lang="scss">
@import './util';
@import './app.scss';
.page-container {
   .main-container {
      display: flex;
      flex-direction: column;
   }

   .content-container {
      flex: 1 1 auto;
      overflow: hidden;
   }

   @media (min-width: 992px) {
      .main-container {
         flex-direction: unset;
      }
   }
}

.content-wrapper {
   position: relative;
   width: 100%;
}

.main-layout {
   display: flex;
   flex-flow: column nowrap;

   @include media-breakpoint-up(lg) {
      flex-flow: row nowrap;
   }
}

// Scoped to .has-sidebar (not every page): PrimaryNavigation.vue's own
// .primary-navigation-container__spacer already reserves the fixed nav's
// exact height for normal page content, so applying this everywhere was
// double-reserving that clearance and adding an extra ~60px gap above the
// page title on mobile (e.g. the home page). But on sidebar pages the
// mobile "Choose an Item" dropdown (SideBar.vue's .side-bar) is itself
// position:fixed, sitting on top of the normal document flow - the page
// title still needs this extra clearance there to avoid sitting underneath
// that fixed dropdown.
@media (max-width: 991px) {
   .main-layout.has-sidebar .container-content {
      padding-top: 60px !important;
   }
}
</style>
